import { useCallback } from 'react'
import { AnalyticsService } from '@/services/analytics'
import { AnalyticsEventPayload, AnalyticsEventType } from '@/interfaces/analytics'

// Thin wrapper over the AnalyticsService singleton (CW2-648 §7.1); the service
// never throws into UI code
export const useAnalytics = () => {
  const track = useCallback((type: AnalyticsEventType, payload?: AnalyticsEventPayload) => {
    AnalyticsService.track(type, payload)
  }, [])

  return { track }
}
